<template>
    <div v-show='isShow' class='layer-pop square-type'>
        <div class='view-content w650'>
            <button class='close' @click='onClickBtnClose'><span class='blind'>팝업 닫기</span></button>
            <div class='scroll-area com-scroll-y'>
                <span class='sub-title'>출결승인</span>
                <div class='attend-info-area'>
          <span class='top-user'><strong
              v-for='(memberName, index) in memberNames'>{{
                  memberNames.length > 1 && index > 0 ? ', ' : ''
              }}{{ memberName }}</strong> 회원님</span>
                    <div class='info-box'>
                        <span class='time'>{{ datetime }} </span>
                        <span v-if='isAttend' class='txt'><span class='blue'>출석처리</span> 되었습니다.</span>
                        <span v-else class='txt'><span class='red'>결석처리</span> 되었습니다.</span>
                    </div>
                </div>
                <div class='bottom-btn'>
                    <!--                    <button class="com-btn" @click="onClickBtnCancel">취소</button>-->
                    <button class='com-btn blue' @click='onClickBtnOk'>확인</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Utils } from '@/assets/js/utils';

export default {
    name: 'AttendOrAbsentSuccessDlg',
    props: {
        memberNames: Array,
        datetime: String,
        isAttend: Boolean,
        isShow: Boolean,
        callbackOk: Function,
        callbackCancel: Function,
    },
    methods: {
        onClickBtnOk() {
            if (!Utils.isEmpty(this.callbackOk)) {
                this.callbackOk();
            }
        },
        onClickBtnClose() {
            if (!Utils.isEmpty(this.callbackOk)) {
                this.callbackOk();
            }
        },
        onClickBtnCancel() {
            if (!Utils.isEmpty(this.callbackCancel)) {
                this.callbackCancel();
            }
        },
    },
};
</script>

<style scoped>

</style>
